import { createContext, useContext, useState, useEffect } from 'react';
import { ACCESS_TOKEN, ADMIN_TOKEN } from '../config/Config';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState('');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const adminToken = localStorage.getItem(ADMIN_TOKEN);
    
    if (token || adminToken) {
      try {
        if (token) {
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const decodedToken = JSON.parse(window.atob(base64));
          
          setUserData(decodedToken);
          setIsLoggedIn(true);
          setRole(decodedToken.rol?.[0] || 'PUPIL');
        }
        
        if (adminToken) {
          setUserData({ name: 'Admin', email: 'admin@yaazhtech.com' });
          setIsLoggedIn(true);
          setRole('ADMIN');
        }
      } catch (error) {
        console.error('Token parsing error:', error);
        logout();
      }
    }
    setLoading(false);
  }, []);
const login = (token, userRole = 'PUPIL') => {
  localStorage.setItem(ACCESS_TOKEN, token);
  
  // Decode token to get user data
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decodedToken = JSON.parse(window.atob(base64));
  
  setUserData(decodedToken);
  setIsLoggedIn(true);
  setRole(userRole);
};

const adminLogin = (token) => {
  localStorage.setItem(ADMIN_TOKEN, token);
  setUserData({ name: 'Admin', email: 'admin@yaazhtech.com' });
  setIsLoggedIn(true);
  setRole('ADMIN');
};

  const logout = () => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(ADMIN_TOKEN);
    setIsLoggedIn(false);
    setRole('');
    setUserData(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        role,
        userData,
        loading,
        login,
        adminLogin,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}